/**
 * Third-party App Accessibility Fixes
 *
 * This script patches accessibility issues in third-party app elements
 * that are injected into the DOM and lack proper ARIA landmarks.
 */

(function () {
  /**
   * Apply accessibility attributes to the wishlist drawer
   * @param {Element} element - The wishlist drawer element
   */
  function fixWishlistDrawer(element) {
    if (!element.hasAttribute('role')) {
      element.setAttribute('role', 'dialog');
      element.setAttribute('aria-label', 'Wunschliste');
      element.setAttribute('aria-modal', 'true');
    }
  }

  /**
   * Check for and fix third-party elements
   */
  function checkAndFixElements() {
    const wishlistDrawer = document.querySelector(
      '.st-wishlist-details.st-wishlist-details--drawer'
    );
    if (wishlistDrawer) {
      fixWishlistDrawer(wishlistDrawer);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndFixElements);
  } else {
    checkAndFixElements();
  }

  // Observe for dynamically injected elements
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        checkAndFixElements();
      }
    });
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
